import React, { Fragment } from 'react'
import { Modal, Button } from 'util/ui'
import styles from './styles.less'

export default function CardFailureModal({ onConfirm, open, error = {} }) {
  let errorMessage
  let isStripeError = false
  if (
    error.errors &&
    error.errors.length > 0 &&
    error.errors[0].status === 400
  ) {
    const backendError = error.errors[0]
    isStripeError = true
    errorMessage = backendError.originalError.body.last_error
  }
  return (
    <Modal open={open} className={styles.billingModal}>
      <Modal.Header>There is a problem with your card</Modal.Header>
      <Modal.Content>
        <div>
          <p>
            {isStripeError && (
              <Fragment>
                Unfortunately we were unable to process your card due to the
                following error provided to us from our payment provider:<br />
                <span className={styles.stripeError}>{errorMessage}</span>
                <br />
                If you require any assistance, please contact our support team
                via email on the following address{' '}
                <a href="mailto:support@groovehq.com">support@groovehq.com</a>
              </Fragment>
            )}
            {!isStripeError && (
              <Fragment>
                Unfortunately we were unable to update your card due to a system
                error.<br />
                <br />
                Please retry or contact our support team to assist via email on
                the following address{' '}
                <a href="mailto:support@groovehq.com">support@groovehq.com</a>
              </Fragment>
            )}
          </p>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button positive onClick={onConfirm}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
